import React from "react";

export const ArrowUpIcon = (props) => {
  return (
    <>
      <svg
        width={36}
        height={36}
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <rect
          y={36}
          width={36}
          height={36}
          rx={18}
          transform="rotate(-90 0 36)"
          fill="#949494"
          style={{
            fill: "#949494",
            fill: "color(display-p3 0.5819 0.5819 0.5819)",
            fillOpacity: 1,
          }}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.5 16.2356L13.6137 21.4092C13.3108 21.7299 12.8006 21.7299 12.4977 21.4092C12.2184 21.1134 12.2184 20.651 12.4977 20.3552L18.5 14L24.5023 20.3552C24.7816 20.651 24.7816 21.1134 24.5023 21.4092C24.1994 21.7299 23.6892 21.7299 23.3863 21.4092L18.5 16.2356Z"
          fill="white"
          stroke="white"
          style={{
            fill: "white",
            fillOpacity: 1,
            stroke: "white",
            strokeOpacity: 1,
          }}
          strokeWidth={0.5}
        />
      </svg>
    </>
  );
};
